import { useSelector } from "react-redux"
import { isRtlLang } from "rtl-detect"

import type { RootState } from "@/types/redux"

const useDirection = (): "rtl" | "ltr" => {
  const currentLanguageCode = useSelector((state: RootState) => state.currentLanguageCode)
  return isRtlLang(currentLanguageCode ?? "") ? "rtl" : "ltr"
}

export default useDirection
